import { useHits } from 'react-instantsearch';
import { HitJob } from '../types';
import TableJobItem from '../../table/TableJobItem';

export default function CustomHitsJobs() {
  const { hits } = useHits<HitJob>({});
  return (
    <>
      <div className="w-full">
        {hits.map((hit) => {
          const {
            id,
            contract_type,
            contract_duration,
            city,
            job_start,
            unit,
            service,
            title,
            date_published,
          } = hit;
          return (
            <TableJobItem
              key={id}
              contract_type={contract_type || ''}
              contract_duration={contract_duration || ''}
              city={city || ''}
              job_start={job_start || ''}
              unit={unit || ''}
              service={service || ''}
              date_published={date_published || ''}
              id={id}
              title={title}
            />
          );
        })}
      </div>
    </>
  );
}
